class Extractor {

  append(instance, key, title, value_sources, value_default){
    const value = this.getData(value_sources, value_default);
    if(!value) return;
    
    if(Array.isArray(value) && value.length === 0) return;
    
    instance[key] = {title: title, value: value};
  }

  extract(data){
    if(data)
      return {'displayLink': data.displayLink, 'link': data.link, 'has_data': 1};
    else
      return {'displayLink': data.displayLink, 'link': data.link, 'has_data': 0};
  }

  setNData(instance, property, list, defaultValue){
    const datum = this.getData(list, defaultValue);

    if(!datum) return;

    if(!Array.isArray(datum)){
      if(!instance[0]) instance[0] = {};
      instance[0][property] = datum;
      return;
    }
    for(var i = 0; i < datum.length; i++){
      if(!instance[i]) instance[i] = {};
      instance[i][property] = datum[i];
    }
  }

  set1Data(instance, property, list, defaultValue){
    instance[property] = this.getData(list, defaultValue);
  }

  getData(list, defaultValue){
    const datum = [];
    var obj, prop, inst;
    for(var i = 0; i < list.length; i++){
      inst = list[i].instance; 
      obj = list[i].object;
      prop = list[i].property;

      if(!inst) continue;

      if(inst[obj]){
        if(!Array.isArray(inst[obj])){
          return (inst[obj][prop]) ? inst[obj][prop] : defaultValue; 
        }
        else {
          if(inst[obj].length === 1){
            if(inst[obj][0][prop]){
              return (inst[obj][0][prop]) ? inst[obj][0][prop] : defaultValue; 
            }
          }
          else {
            for(var j = 0; j < inst[obj].length; j++){
              if(inst[obj][j][prop]){
                datum.push(inst[obj][j][prop]);
              }
            }
            return datum;
          }
        }
      }
    }

    return defaultValue;
  }
}

export default (Extractor);


// WEBPACK FOOTER //
// ./src/search/extractor/extractor.js